<div *ngIf="_properties">
  <p [innerHTML]="_properties.text1" class="title3 centered"></p>
  <p [innerHTML]="_properties.text2" class="title3 centered"></p>
  <div class="center">
    <app-countdown *ngIf="_properties.countdown" [countdown]="_properties.countdown" (complete)="moveNext()"></app-countdown>
    <app-confetti *ngIf="_properties.confetti"></app-confetti>
    <button *ngIf="_properties.text3" id="actionButton" class="btn btn-primary btn-lg" (click)="moveNext()" [innerHTML]="_properties.text3"></button>
  </div>
</div>
